<template>
  <div class="payment-complete">
    <HeaderComponent/>
    <section id="payments" class="payments">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>Payment Completed</h2>
        </div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from "@/components/Header"
import FooterComponent from "@/components/Footer"
import axios from "axios";
export default {
  name: "PaymentCompleted",
  data() {
    return {
      txID: '',
      txnAMount: '',
      spCode: '',
      spCodeDes: '',
      paymentOption: ''
    }
  },
  mounted() {
    this.txID = this.$route.query.txID;
    this.txnAMount = this.$route.query.txnAMount;
    this.spCode = this.$route.query.spCode;
    this.spCodeDes = this.$route.query.spCodeDes;
    this.paymentOption = this.$route.query.paymentOption;
    this.topupNow();
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  methods: {
    topupNow() {
      let t_mobile = localStorage.getItem('mobile');
      let t_operator = localStorage.getItem('operator');
      let t_type = localStorage.getItem('type');
      let t_amount = localStorage.getItem('amount');
      if (t_mobile != null && t_operator != null) {
        let instance = this;
        const access_token = localStorage.getItem('access_token');
        axios.post(`${this.apiPath}single-topup-client`,{
          mobile: t_mobile,
          operator: t_operator,
          type: t_type,
          amount: t_amount,
          spCode: this.spCode,
          spCodeDes: this.spCodeDes
        },{
          headers: {
            Authorization: access_token
          }
        }).then(function (response){
          console.log(response.data)
          instance.$router.push('/thank-you');
        }.bind()).catch(function (error){
          console.log(error.response)
        });
      }
    }
  }
}
</script>

<style scoped>
.payment-complete {
  margin-top: 40px;
}
</style>